import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	margin: 2em 0;
	padding: 3em 0;
	background-color: ${vars.colorElement};

	.headline {
		font-size: 1.1em;
		font-weight: 700;
		text-align: center;

		.underline {
			position: relative;
			width: 100%;
			z-index: 2;

			.background-yellow-small {
				position: absolute;
				width: 120%;
				height: 100%;
				top: 0;
				left: -7%;
				background-image: url(/images/job/job/underline-yellow-small.svg);
				background-repeat: no-repeat;
				background-position: center;
				background-size: contain;

				z-index: -1;
			}
		}
	}

	.list {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		gap: 3em;
		padding: 3em 5.5em 0;

		.list-element {
			width: 21%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			text-align: center;

			.element-content {
				padding-top: 1em;
			}
		}

		&.longList {
			flex-wrap: wrap;
			justify-content: flex-start;
			.list-element {
				width: 20%;
			}
		}
	}

	@media all and (max-width: ${vars.tabletS}) {
		.list {
			flex-wrap: wrap;
			padding: 3em 1.6em 0;

			.list-element {
				width: 45%;
				padding-top: 1em;

				.element-content {
					width: 100%;
				}
			}
			&.longList {
                .list-element {
                width: 45%;

            }
        }
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		margin-bottom: 2em;

		.layout-container {
			max-width: 100%;
			width: 100%;
		}
	}

    @media all and (max-width: ${vars.mobileM}) {
        .list {
            .list-element {
                width: 100%;
            }
            &.longList {
                .list-element {
                    width: 100%;

            }
        }
        }
    }
`;
